(() => {
  const country = String(
    document.documentElement.dataset.country ||
    window.Shopify?.country ||
    ''
  ).toUpperCase();

  if (country !== 'BE') return;

  const normalize = value => String(value || '')
    .replace(/\u00a0/g, ' ')
    .replace(/\s+/g, ' ')
    .trim();

  const exact = new Map(Object.entries({
    'Voor 16:00 besteld,': 'Snel verzonden,',
    'VOOR 16:00 BESTELD,': 'SNEL VERZONDEN,',
    'de volgende werkdag in huis.': 'levering binnen 2 tot 3 werkdagen.',
    'DE VOLGENDE WERKDAG IN HUIS.': 'LEVERING BINNEN 2 TOT 3 WERKDAGEN.',
    'Voor 16:00 besteld, de volgende werkdag in huis.': 'Snel verzonden, levering binnen 2 tot 3 werkdagen.',
    'VOOR 16:00 BESTELD, DE VOLGENDE WERKDAG IN HUIS.': 'SNEL VERZONDEN, LEVERING BINNEN 2 TOT 3 WERKDAGEN.',
    'Bestel op een werkdag voor 16:00, dan is je pakket de volgende werkdag in huis.': 'Je bestelling wordt snel verzonden. De levering naar België duurt 2 tot 3 werkdagen.',
    'Gratis verzending vanaf €49,95.': 'Verzending naar België voor €5,95.',
    'Gratis verzending vanaf €49,95': 'Verzending naar België voor €5,95',
    'GRATIS VERZENDING VANAF €49,95.': 'VERZENDING NAAR BELGIË VOOR €5,95.',
    'GRATIS VERZENDING VANAF €49,95': 'VERZENDING NAAR BELGIË VOOR €5,95',
    'Gratis verzending': 'Verzending naar België',
    'GRATIS VERZENDING': 'VERZENDING NAAR BELGIË',
    'vanaf €49,95.': 'voor €5,95.',
    'vanaf €49,95': 'voor €5,95',
    'VANAF €49,95.': 'VOOR €5,95.',
    'VANAF €49,95': 'VOOR €5,95',
    'Shipping is calculated based on your location and the items in your order. You will always know the shipping price before you purchase.': 'Verzending naar België kost €5,95. Je ziet dit bedrag ook bij het afrekenen.',
    'How much does shipping cost?': 'Hoeveel kost verzending naar België?',
    'FREE SHIPPING ON EU ORDERS ABOVE 300$': 'VERZENDING NAAR BELGIË VOOR €5,95',
    'Daaronder verzendkosten slechts €3,95 Bestel op een werkdag voor 16:00, dan is je pakket de volgende werkdag in huis.': 'Verzending naar België kost €5,95. De levering duurt 2 tot 3 werkdagen.',
    'Daaronder verzendkosten slechts €3,95': 'Verzending naar België kost €5,95.',
    'Verzending naar België voor €6,95.': 'Verzending naar België voor €5,95.',
    'Verzending naar België kost €6,95.': 'Verzending naar België kost €5,95.'
  }));

  function localize(value) {
    const normalized = normalize(value);
    if (!normalized) return value;
    if (exact.has(normalized)) return exact.get(normalized);

    let output = String(value);
    output = output.replace(/Nu besteld,\s*(?:maandag|dinsdag|woensdag|donderdag|vrijdag|zaterdag|zondag)\s+in huis\.?/gi, 'Nu besteld, levering binnen 2 tot 3 werkdagen.');
    output = output.replace(/Besteld voor\s*16:00[^.]*volgende werkdag[^.]*\.?/gi, 'Snel verzonden, levering binnen 2 tot 3 werkdagen.');
    output = output.replace(/2\s*(?:tot|-)\s*4\s*werkdagen/gi, '2 tot 3 werkdagen');
    output = output.replace(/verzend(?:ing|kosten)\s+naar\s+België\s+(?:voor|kost(?:en)?)\s*€?\s*6[,.]95/gi, 'Verzending naar België voor €5,95');
    return output;
  }

  function localizeTextNode(node) {
    if (!node || node.nodeType !== Node.TEXT_NODE || !node.parentElement) return;
    if (node.parentElement.closest('script, style, noscript, textarea, [data-chevalier-no-localize]')) return;
    const translated = localize(node.nodeValue);
    if (translated !== node.nodeValue) node.nodeValue = translated;
  }

  function localizeAttributes(root = document) {
    root.querySelectorAll?.('[placeholder], [title], [aria-label]').forEach(element => {
      ['placeholder', 'title', 'aria-label'].forEach(attribute => {
        if (!element.hasAttribute(attribute)) return;
        const current = element.getAttribute(attribute);
        const translated = localize(current);
        if (translated !== current) element.setAttribute(attribute, translated);
      });
    });
  }

  function walk(root = document.body) {
    if (!root) return;
    if (root.nodeType === Node.TEXT_NODE) return localizeTextNode(root);
    const walker = document.createTreeWalker(root, NodeFilter.SHOW_TEXT);
    const nodes = [];
    while (walker.nextNode()) nodes.push(walker.currentNode);
    nodes.forEach(localizeTextNode);
    localizeAttributes(root.nodeType === Node.DOCUMENT_NODE ? root : root);
  }

  function hideFreeShippingProgress(root = document) {
    root.querySelectorAll?.('[id^="ss-fsbar-"], [class*="ss-fsbar-section-"]').forEach(element => {
      element.style.setProperty('display', 'none', 'important');
      element.setAttribute('aria-hidden', 'true');
    });
  }

  function enhanceShadowRoots(root = document) {
    root.querySelectorAll?.('*').forEach(element => {
      if (element.shadowRoot) enhance(element.shadowRoot);
    });
  }

  function enhanceFrames() {
    document.querySelectorAll('iframe').forEach(frame => {
      try {
        const doc = frame.contentDocument;
        if (doc?.body) enhance(doc);
      } catch (_) {}
    });
  }

  function enhance(root = document) {
    walk(root.body || root);
    hideFreeShippingProgress(root);
    enhanceShadowRoots(root);
  }

  let scheduled = false;
  const schedule = () => {
    if (scheduled) return;
    scheduled = true;
    requestAnimationFrame(() => {
      scheduled = false;
      enhance(document);
      enhanceFrames();
    });
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', schedule, { once: true });
  } else {
    schedule();
  }

  new MutationObserver(schedule).observe(document.documentElement, {
    subtree: true,
    childList: true,
    characterData: true,
    attributes: true,
    attributeFilter: ['placeholder', 'title', 'aria-label']
  });

  window.addEventListener('load', schedule, { once: true });
  setTimeout(schedule, 400);
  setTimeout(schedule, 1200);
  setTimeout(schedule, 3000);
})();
